import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as Caret } from '../images/caret.svg'
import { classes } from '../utils/components'
import Link from './link'

const Button = ({ className, darkMode, title, uri, disabled, ...props }) => {
  const buttonContent = (
    <>
      <span className="mr-3 whitespace-no-wrap xl:text-xl">{title}</span>
      <Caret
        className={`inline-block stroke-3 ${
          darkMode ? 'stroke-brand-navy' : 'stroke-brand-cyan'
        }`}
      />
    </>
  )

  return uri ? (
    <Link
      className={classes(
        className,
        darkMode ? 'bg-brand-cyan' : 'bg-secondary',
        disabled && 'pointer-events-none',
        'text-secondary font-bold px-4 py-2 flex items-center rounded-full'
      )}
      to={uri || '#'}
      {...props}
    >
      {buttonContent}
    </Link>
  ) : (
    <button
      className={classes(
        className,
        darkMode ? 'bg-brand-cyan' : 'bg-secondary',
        disabled && 'pointer-events-none',
        'text-secondary font-bold px-4 py-2 flex items-center rounded-full'
      )}
      {...props}
    >
      {buttonContent}
    </button>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  darkMode: PropTypes.bool,
  title: PropTypes.string,
  uri: PropTypes.string,
  disabled: PropTypes.bool,
  props: PropTypes.object,
}

export default Button
